module.exports = __webpack_public_path__ + "img/projektovani.20ed429a.svg";